import React, { useState, useEffect, useRef } from 'react';
import './DecimalInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function DecimalInput({ initialValue, rules, onValidate, name, label, instructions, showError, errorMessages, readOnly, tabIndex }) {
  const [value, setValue] = useState((initialValue ? initialValue : ''));
  const [isValid, setIsValid] = useState(null);
  const [validationDetails, setValidationDetails] = useState(null);


  const valueRef = useRef((initialValue ? initialValue : ''));


  const setValueRef = (el) => {
    if (logComponent('DecimalInput')) { console.debug('DecimalInput setValueRef'); }
    valueRef.current = el;
    setValue(el);
  }

  if (logComponent('DecimalInput')) { console.debug('DecimalInput rendered'); }


  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('DecimalInput')) { console.debug('DecimalInput setNativeCheckboxRef'); }
    validateThis();
  }, []);


  const updateValue = (e) => {
    if (logComponent('DecimalInput')) { console.debug('DecimalInput updateValue'); }
    setValueRef(e.target.value);
    
  }

  const validateThis = () => {
    if (logComponent('DecimalInput')) { console.debug('DecimalInput validateThis'); }

    let rulesToCheck = Object.assign({}, rules);
    if (rulesToCheck == null) {
      rulesToCheck = {};
    }

    if (rules.required || (valueRef.current && valueRef.current.length > 0)) {
      rulesToCheck.validDecimal = true;
    }

    let validationDetails = {};

    for (let rule in rulesToCheck) {
     validationDetails[rule] = validate[rule](valueRef.current, rulesToCheck[rule]);
    }

    let isValidLocal = Object.values(validationDetails).reduce((prev, curr) => prev && curr, true);

    setValidationDetails(validationDetails);
    setIsValid(isValidLocal);



    onValidate({
      name: name,
      isValid: isValidLocal,
      value: valueRef.current
    });  
  }  

  const handleBlur = () => {
    if (logComponent('DecimalInput')) { console.debug('DecimalInput handleBlur'); }
    validateThis();
  }

  return (
    <div className="Decimal-Input-Group">
    {
      showError && !isValid &&
      errorMessages.map((message, index) => {
        return <p key={index} className="Decimal-Input-Group__error">{message}</p>; 
      })
    }   
      <label 
        className="Decimal-Input-Group__label"
        htmlFor={name + '-input'}>
              {label}{
        rules && rules.required &&
        <span className="Decimal-Input-Group__required"> *</span>
}
      </label>
      <input 
        id={name + '-input'}
        className="Decimal-Input-Group__input" 
        type="text"
        spellCheck="false"
        tabIndex={tabIndex}
        readOnly={readOnly}
        value={value}
        onChange={updateValue}
        onBlur={handleBlur} />
      { 
        instructions &&
        <span className="Decimal-Input-Group__instructions">{ instructions }</span>
      }      
    </div>
  );
}